<template>
  <div class="heroes">
    <div class="intro" v-if="intro">
      <div class="overlay first"></div>
      <div class="overlay second">
        <img class="marvel" src="../assets/marvel.png" alt="">
      </div>
      <div class="overlay third"></div>
    </div>
    
    <!-- <img class="logo" alt="X-Men logo" src="../assets/logo.png" /> -->
   <div class="title">
    <div class="logo">
      <img class="logo1" alt="X-Men logo" src="../assets/logo.png" />
    </div>
    
   </div>
   <h4 class="click">Click in the Heroe!</h4>
   <div class="music">
      <Music/>
    </div>
   <div class="jeangrey">
      <img
        class="jean"
        v-on:click="viewCharacter(storm)"
        alt="X-Men logo"
        src="../assets/storm.png"
        v-if="display1"
      />
      
    </div>
    <Fichatecnica class="tormenta" v-if="displayA" :name="storm" @close="closeCards" :error_message="error_mesage"/>
    <div class="guepardo">
      <img
        class="wolverine"
        v-on:click="viewCharacter(wolverine)"
        alt="X-Men logo"
        src="../assets/wolverine.png"
        v-if="display2"
      />
      
    </div>
    <Fichatecnica class="cardguepardo" v-if="displayB" :name="wolverine" @close="closeCards" :error_message="error_mesage"/>

    <div class="coloso">
      <img
        class="colosus"
        v-on:click="viewCharacter(colosus)"
        alt="X-Men logo"
        src="../assets/colosus.png"
        v-if="display3"
      />
      
    </div>
    <Fichatecnica class="cardcoloso" v-if="displayC" :name="colosus" @close="closeCards" :error_message="error_mesage" />
    
     <div class="ciclope">
      <img
        class="cyclops"
        @click="viewCharacter(cyclops)"
        alt="X-Men logo"
        src="../assets/cyclops1.png"
        v-if="display4"
      />
      
    </div>
    <Fichatecnica class="cardciclope" v-if="displayD" :name="cyclops" @close="closeCards" :error_message="error_mesage" />

    <div class="titania">
      <img
        class="rogue"
        v-on:click="viewCharacter(rogue)"
        alt="X-Men logo"
        src="../assets/roque.png"
        v-if="display5"
      />
      
    </div>
    <Fichatecnica class="cardtitania" v-if="displayE" :name="rogue"  @close="closeCards" :error_message="error_mesage"/>
    <FooterComponent class="footer"/>
  </div>
</template>
<script>
import { public_key } from "../marvel";
import axios from "axios";
import { gsap } from "gsap";
import Fichatecnica from "./Fichatecnica.vue";
import Music from './Music.vue';
import FooterComponent from './FooterComponent.vue';

export default {
  components: { Fichatecnica , Music, FooterComponent },
  name: "Character",
  data() {
    return {
      cyclops: 1009257,
      wolverine: 1009718,
      colosus: 1009243,
      rogue: 1009546,
      storm: 1009629,
      displayA: false,
      display1: true,
      displayB: false,
      display2: true,
      displayC: false,
      display3: true,
      displayD: false,
      display4: true,
      displayE: false,
      display5: true,
      heroe: "",
      error_mesage: false,
      intro: true
    };
  },
  //  props: ['close'],

  created() {
    
  },
  mounted() {
    this.getCharacter();
    this.animation();
    // this.deleteDivs()
  },
  

  methods: {
    getCharacter() {
      axios
        .get(
          `https://gateway.marvel.com/v1/public/characters?apikey=${public_key}`
        )
        .then((result) => {
          console.log(result);
        })
        .catch((error) => {
          console.log(error);
          this.error_mesage= true
        });
    },
    viewCharacter(heroe) {
      // this.resetFields();
      this.heroe = heroe;
      if(heroe === 1009629){
       this.displayA = true;
       this.display1 = false; 
      }
      if(heroe === 1009718){
       this.displayB = true;
       this.display2 = false; 
      }
      if(heroe === 1009243){
       this.displayC = true;
       this.display3 = false; 
      }
      if(heroe === 1009257){
       this.displayD = true;
       this.display4 = false; 
      }
      if(heroe === 1009546){
       this.displayE = true;
       this.display5 = false; 
      }

      
      
      console.log(this.heroe);
     
      
    },
    

    animation() {
      gsap.from(".jeangrey", {
        delay: 2.7,
        opacity: 0,
        x: -200,
        ease: "expo.out",
      });

      gsap.from(".guepardo", {
        delay: 2.8,
        opacity: 0,
        x: -500,
        ease: "expo.out",
      });

      gsap.from(".coloso", {
        delay: 2.9,
        opacity: 0,
        y: -500,
        ease: "expo.out",
      });

      gsap.from(".ciclope", {
        delay: 3.0,
        opacity: 0,
        x: 500,
        ease: "expo.out",
      });

      gsap.from(".titania", {
        delay: 3.2,
        opacity: 0,
        x: 200,
        ease: "expo.out",
      });

      gsap.from(".logo", {
        delay: 3.6,
        opacity: 0,
        y: -200,
        ease: "expo.out",
      });
      
      gsap.to(".first", {
        delay: 2.2,
        left: "-100%",
        ease: "expo.inOut",
      });

      gsap.to(".second", {
        delay: 2.4,
        left: "-100%",
        ease: "expo.inOut",
      });

      gsap.to(".third", {
        delay: 2.6,
        left: "-100%",
        ease: "expo.inOut",
      });
      setTimeout(this.deleteDivs(),3000)
      
    },
    closeCards(heroe) {
       console.log(heroe);
       if(heroe === 1009629){
       this.displayA = false;
       this.display1 = true; 
      }
      if(heroe === 1009718){
       this.displayB = false;
       this.display2 = true; 
      }
      if(heroe === 1009243){
       this.displayC = false;
       this.display3 = true; 
      }
      if(heroe === 1009257){
       this.displayD = false;
       this.display4 = true; 
      }
      if(heroe === 1009546){
       this.displayE = false;
       this.display5 = true; 
      }

    },
    deleteDivs(){
      this.intro = true
      setTimeout(() => {
       this.intro = false 
      }, 3000);
      
    }
  },
};
</script>
<style>
.heroes{
  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "tormenta . click . titania"
    "tormenta . coloso . titania"
    ". guepardo coloso ciclope ."
    ". guepardo coloso ciclope .";
  grid-area: characters; */
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  position:absolute
}
.cyclops {
   height: 90%;
  width: 90%;
  
}
.wolverine {
   height: 90%;
   width: 90%;
  position:relative;
  /* z-index: 2; */
}
.rogue {
    height: 90%;
  width: 90%;
}
.colosus {
    height: 90%;
  width: 65%;
   display:flex;
}
.jean {
    height: 90%;
  width: 90%;
}
.ciclope{
   height:300px;
  width:300px;
  /* transform: translate(70px,100px);
  display:flex;
 justify-content: center; */
 grid-area: 3 / 7 / 6 / 9;
   
}
.guepardo{
   height:250px;
  width:250px;
  /* display:flex;
 justify-content: center;
  transform: translate(-50px,150px);
  position: relative;
  z-index: 30; */
  grid-area: 3 / 3 / 6 / 5;;
}
.coloso{
   height:350px;
  width:300px;
  /* display:flex;
 justify-content: center;
 transform: translate(-70px,); */
 grid-area:  4 / 5 / 7 / 7;
}
.jeangrey{
  height:250px;
  width:250px;
  /* transform: translate(50px,-150px); */
  grid-area: 1 / 1 / 4 / 3; 
  /* z-index: 10; */
}

.titania{
   height:250px;
  width:250px;
  /* transform: translate(-100px,-150px);
  display:flex;
 justify-content: center; */
 grid-area: 1 / 9 / 4 / 11;
}

.card{
  height:100%;
  width:100%
}
.tormenta{
  grid-area: 1 / 1 / 3 / 5; 
  position: absolute;
  z-index: 10;
  /* display: grid; 
  grid-template-columns: 1fr 1fr 1fr 1fr; 
  grid-template-rows: 1fr 1fr 1fr 1fr; 
  gap: 0px 0px; 
  grid-template-areas: 
    "foto foto name name"
    "foto foto name name"
    "comics comics comics comics"
    "comics comics comics comics";  */
}
/* .jeangrey:before{
content:'';
position:absolute;
top:0;
left:0;
background-color: #000000;
width:100%;
height:100%;
opacity:0;
transition:opacity 500ms;
z-index:100;
}
.jeangrey:hover:before{
opacity:0.4;
}
.jeangrey:after{
content:"Click Here!";
position:absolute;
display:block;
width:100%;
top:50%;
text-align:center;
font-family:Segoe, "Segoe UI", "DejaVu Sans", "Trebuchet MS", Verdana, "sans-serif";
font-size: 1.5rem;
color: white;
opacity:0;
transition:opacity 500ms;
z-index: 200;
}
.jeangrey:hover:after{
opacity:1;
} */
.jeangrey img{
transform: scale(1);
transition: transform 1000ms;
z-index:0;
}
.jeangrey:hover img{
transform: scale(1.2);
}
.jeangrey a:after{
content: "";
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
z-index: 300;
}

.guepardo img{
transform: scale(1);
transition: transform 1000ms;
/* z-index:10; */
}
.guepardo:hover img{
transform: scale(1.2);
}
.guepardo a:after{
content: "";
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
z-index: 300;
}

.coloso img{
transform: scale(1);
transition: transform 1000ms;
z-index:0;
}
.coloso:hover img{
transform: scale(1.2);
}
.coloso a:after{
content: "";
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
z-index: 300;
}

.titania img{
transform: scale(1);
transition: transform 1000ms;
z-index:0;
}
.titania:hover img{
transform: scale(1.2);
}
.titania a:after{
content: "";
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
z-index: 300;
}

.ciclope img{
transform: scale(1);
transition: transform 1000ms;
z-index:0;
}
.ciclope:hover img{
transform: scale(1.2);
}
.ciclope a:after{
content: "";
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
z-index: 300;
}
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0%;
  z-index: 2;
  background: #e61d02;
}

.first {
  top: 0;
}

.second {
  top: 33.3%;
  display: flex;
  justify-content: center;
  
}

.third {
  top: 66.6%;
}

.marvel{
  width: 30%;
  height: 40%;
}
.click { 
  grid-area: 3 / 5 / 4 / 7;
  text-align: center;
  color: #fff;
	margin-top: 5%;
	text-shadow:
		0 0 5px rgba(0,178,255,1),
		0 0 10px rgba(0,178,255,1),
		0 0 20px rgba(0,178,255,1),
		0 0 40px rgba(38,104,127,1),
		0 0 80px rgba(38,104,127,1),
		0 0 90px rgba(38,104,127,1),
		0 0 100px rgba(38,104,127,1),
		0 0 140px rgba(38,104,127,1),
		0 0 180px rgba(38,104,127,1);
}
.title{
 display: grid;
 grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
 grid-template-rows: 1fr 1fr 1fr;
 gap: 0px 0px;
 grid-auto-flow: row;
 grid-template-areas:
 ". logo logo logo ."
 ". logo logo logo ."
 ". logo logo logo .";
 grid-area: 1 / 3 / 3 / 9;

}
.logo1{
  width:80%;
  padding: 10px;
  align-self: center;
  
}
 .logo { 
  grid-area: logo;
  display: flex;
   align-items: center;
   justify-content: center;
  
}
.music {
  grid-area: 5 / 1 / 6 / 3;; 
  margin-top: 0%;
}
.cardguepardo{
  grid-area: 3 / 1 / 5 / 5;
  z-index: 90;
  position: absolute;
}
.cardcoloso{
  grid-area: 5 / 4 / 7 / 8;
  position: absolute;
}
.cardciclope{
  grid-area: 3 / 7 / 5 / 11; 
  position: absolute;
}
.cardtitania{
  grid-area: 1 / 7 / 3 / 11;
  position: absolute;
}

.footer { 
  grid-area: 7 / 1 / 8 / 12; 
  
}
</style>